import logo from './logo.svg';
import Typing from './Typing';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Typing />
      </header> 
    </div>
  );
}

export default App;
